import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../types';
import { handleError } from '../../../components/ui/err/handleError';
import { queries } from '../../queries';

export default function useGetCompanies(params: { page: number; size?: number; searchWord?: string; searchType?: string }) {
  return useQuery({
    ...queries.company.list(params),
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
